import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HISTORY_KEY } from "src/constants/UrlConstants";
import { MAX_HISTORY_ENTRIES, ROUTE_PATHS } from "src/utils/constants";
import { createCookie, getCookie } from "src/utils/cookies";

const EXCLUDED_ROUTES = [ROUTE_PATHS.CHECKOUT, ROUTE_PATHS.ASK_FOR_DETAILS];

const useNavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    const shouldExclude = EXCLUDED_ROUTES.some((route) =>
      path.startsWith(route),
    );

    if (!shouldExclude) {
      const stored = Array.isArray(getCookie(HISTORY_KEY))
        ? getCookie(HISTORY_KEY)
        : [];

      if (stored.length === 0 || stored[stored.length - 1] !== path) {
        stored.push(path);

        const limitedHistory =
          stored.length > MAX_HISTORY_ENTRIES
            ? stored.slice(-MAX_HISTORY_ENTRIES)
            : stored;

        createCookie(
          HISTORY_KEY,
          encodeURIComponent(JSON.stringify(limitedHistory)),
          null,
        );
      }
    }
  }, [location]);
};

export default useNavigationTracker;
